const { webviewRoutesArray } = require('src/router/webview-routes')

export default (locale) => [
  {
    path: `/${locale}/livechat`,
    name: 'livechat',
    component: () => import('pages/LivechatPage.vue'),
  },
  {
    name: 'webview',
    path: `/${locale}/webview`,
    component: () => import('layouts/WebviewLayout.vue'),
    children: webviewRoutesArray,
  },
]
